import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reports-screen',
  templateUrl: './reports-screen.component.html',
  styleUrls: ['./reports-screen.component.scss']
})
export class ReportsScreenComponent implements OnInit {
  reports = [
    { id: 1, address: '74, Cleveland Centre, Linthorpe Road, Middlesborough', postcode: 'TS1 2LA', type: 'EPC', isOnline: false },
    { id: 2, address: 'First Floor Flat, 11 St James Parade, Bath', postcode: 'BA1 1UL', type: 'EPC', isOnline: false },
    { id: 3, address: '30 Conigre Square, Trowbridge', postcode: 'BA14 8LJ', type: 'EPR', isOnline: false },
    { id: 4, address: '41 Horsefields, Gillingham, Dorset', postcode: 'SP8 4UQ', type: 'EPC', isOnline: true },
    { id: 5, address: '75, Cleveland Centre, Linthorpe Road, Middlesborough', postcode: 'TS1 2LA', type: 'EPC', isOnline: false },
    { id: 6, address: '22 Conigre Square, Trowbridge', postcode: 'BA14 8LJ', type: 'EPR', isOnline: false },
  ];

  isHovered: { [key: number]: boolean } = {};
  showModal: boolean = false;
  reportToDelete: number | null = null;
  showCloudModal: boolean = false;
  reportToToggleOnline: number | null = null;

  constructor() {}

  ngOnInit(): void {}

  confirmDelete(reportId: number) {
    this.showModal = true;
    this.reportToDelete = reportId;
  }

  deleteReport() {
    if (this.reportToDelete !== null) {
      this.reports = this.reports.filter(report => report.id !== this.reportToDelete);
      this.cancelDelete();
    }
  }

  cancelDelete() {
    this.showModal = false;
    this.reportToDelete = null;
  }

  confirmToggleOnline(reportId: number) {
    this.showCloudModal = true;
    this.reportToToggleOnline = reportId;
  }

  toggleOnlineStatus() {
    if (this.reportToToggleOnline !== null) {
      const report = this.reports.find(report => report.id === this.reportToToggleOnline);
      if (report) {
        report.isOnline = !report.isOnline;
      }
      this.cancelToggleOnline();
    }
  }

  cancelToggleOnline() {
    this.showCloudModal = false;
    this.reportToToggleOnline = null;
  }
}